import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { ConfigProvider } from '@mydocma/common';
import { MYDOCMASETTINGS } from '@mydocma/core';
import { APP_CONTAINER_SETTINGS } from '@mydocma/app-container';
import { AUTHSETTINGS, AUTHSTORAGE } from '@mydocma/auth';
import { TASK_CONFIG, WEBSOCKET_CONFIG as MYDOCMA_WEBSOCKET_CONFIG } from '@mydocma/task';
import { FILES_API_SETTINGS, JF_SETTINGS, JfConfig } from 'projects/mydocma/jf/src/lib/jf-config/jf-config.interface';
import { PIX_CONFIG, PIX_SETTINGS } from '@mydocma/pix-common';
import {LOGGER_CONFIG} from '@mydocma/common/src/lib/logger';

if (environment.production) {
  enableProdMode();
}

async function main() {

    try {
      const configProvider = new ConfigProvider<JfConfig>(null);
      const config = await configProvider.loadConfigAsync();

      await platformBrowserDynamic([
        {provide: AUTHSETTINGS, useValue: config.authConfig},
        {provide: AUTHSTORAGE, useValue: sessionStorage},
        {provide: MYDOCMASETTINGS, useValue: config.mydocmaConfig},
        {provide: APP_CONTAINER_SETTINGS, useValue: config.appContainerConfig},
        {provide: TASK_CONFIG, useValue: config.taskConfig},
        {provide: MYDOCMA_WEBSOCKET_CONFIG, useValue: config.webSocketConfig},
        {provide: PIX_CONFIG, useValue: config.pixConfig},
        {provide: PIX_SETTINGS, useValue: config.pixConfig},
        {provide: JF_SETTINGS, useValue: config.jfConfig},
        {provide: FILES_API_SETTINGS, useValue: config.filesApiConfig},
        {provide: LOGGER_CONFIG, useValue: config},
      ]).bootstrapModule(AppModule).then(() => {})
    } catch (error) {
      console.error(error);
    }
  }

  main()
